// local lib
import extractInnovationScore from './extractInnovationScore.lib';

const renderInnovationChart = ({company}) => {
  const {average, innovationScore} = extractInnovationScore({company});
  return !!average.length || !!innovationScore.length;
};

export default renderInnovationChart;
